import { Card, useToast } from "alm-react-components";
import { useContext, useEffect, useState } from "react";
import Notification from "../../../assets/images/svgicons/notifications-tab.svg";
import dailyReminderImg from "../../../assets/images/svgicons/lightbulb_line_icon_1.svg";
import { AppContext } from "../../../context/AppProvider";
import { useTranslation } from "react-i18next";
import { ActionType, StatusCode } from "../../../assets/constants/constants";
import {
  getUserNotificationSettings,
  updateUserNotificationSettings,
} from "../../../services/user";
import PageLoader from "../../common/loader/PageLoader";
import useGaEventTracking from '../../../hooks/UseGaEventTracking';
import { analytics_category, analytics_event, analytics_label } from '../../../assets/constants/staticContentConstants';
import useAlmCorporateStatus from "../../../hooks/useAlmCorporateStatus";
import Tooltip from "../../common/Tooltip";

export const NotificationSetting = () => {
  const { toast } = useToast();
  const gaEventTracker = useGaEventTracking();

  const { state, dispatch } = useContext(AppContext);
  const { t } = useTranslation();
  const [dailyAnnouncement, setDailyAnnouncement] = useState(false);
  const [notification, setNotification] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (state?.user?.email) {
      setUserNotificationSettings();
    }
  }, [state?.user]);

  useAlmCorporateStatus();

  const setUserNotificationSettings = async () => {
    setLoading(true);
    getUserNotificationSettings()
      .then((res: any) => {
        if (res.status === 200) {
          setNotification(res?.data?.enableOtherNotification);
          setDailyAnnouncement(res?.data?.enableDailyRemainder);
        } else {
          dispatch({
            type: ActionType.ERROR,
            payload: {
              type: "UnAuthorizedUser",
              message: t("ErrorType.retryAgain"),
            },
          });
        }
      })
      .catch(() => {
        dispatch({
          type: ActionType.ERROR,
          payload: {
            type: "UnAuthorizedUser",
            message: t("ErrorType.retryAgain"),
          },
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onUpdate = (data: any) => {
    updateUserNotificationSettings(data).then((res: any) => {
      if (res.status === StatusCode.SUCCESS)
        dispatch({ type: ActionType.NOTIFICATION_SETTING, payload: data });
      toast({
        description: t("Common.notificationsSettingUpdate"),
        variant: "success",
      });
    });
  };
  const onChageNotification = (flag: boolean) => {
    setNotification(flag);
    const data = {
      enableOtherNotification: flag ? 1 : 0,
      enableDailyRemainder: dailyAnnouncement ? 1 : 0,
    };
    onUpdate(data);
  };
  const onChageDailyAnnouncement = (flag: boolean) => {
    const data = {
      enableOtherNotification: notification ? 1 : 0,
      enableDailyRemainder: flag ? 1 : 0,
    };
    setDailyAnnouncement(flag);
    onUpdate(data);
    const items = {
      value: null,
      currency: null,
      transaction_id: null,
      items: [{}],
      userId:state.user?.userId,
  };
    if(flag){ 
      gaEventTracker(analytics_event.pushNotification,analytics_category.buttonClickPushNotifiction,analytics_label.pushNotificationsLable("Accepted"),items);
      }else{  
      gaEventTracker(analytics_event.pushNotification,analytics_category.buttonClickPushNotifiction,analytics_label.pushNotificationsLable("Disabled"),items);
      }
  };
  return (
    <>
      {loading ? (
        <PageLoader />
      ) : (
        <div className="lg:flex lg:items-center lg:justify-between relative">
          <div className="min-w-0 flex-1 md:pb-6 lg:pb-6">
            <h1 className="text-base lg:text-2xl font-barlowSemiBold pb-3">
              {t("UserSettings.notifications")}
            </h1>
            <p
              className="text-base"
              dangerouslySetInnerHTML={{
                __html: t(
                  "UserSettings.manageYourPersonalNotificationSettings"
                ),
              }}
            />
          </div>
        </div>
      )}

      <Card className="w-full my-2 px-4 py-2 bg-white border border-gray-200 rounded-lg shadow dark:bg-fillLightGrayCard dark:border-gray-700">
        <div className="flow-root">
          <ul
            role="list"
            className="divide-y divide-gray-200 dark:divide-gray-700"
          >
            <li className="py-3 sm:py-4">
              <div className="flex items-center">
                <div className="flex-shrink-0 flex items-center">
                  <img
                    className="w-[16px] h-[16px] "
                    alt="No Image"
                    src={Notification}
                  />
                </div>
                <div className="flex-1 min-w-0 ms-4 flex items-center">
                  <Tooltip
                    title={t("UserSettings.notificationsTooltip")}
                    position="right"
                    className="bg-[#16171C] p-2 text-center border dark:border-white z-[10000] text-xs -mt-2 ml-2"
                  >
                    <p className="text-sm font-helveticaRegular truncate text-gray-900 dark:text-white my-0">
                      {t("Common.notifications")}
                    </p>
                  </Tooltip>
                </div>
                <div className="inline-flex items-center text-sm font-light text-gray-900 dark:text-white">
                  <label className="inline-flex items-center cursor-pointer">
                    <span className="ms-3 px-4 text-sm font-medium uppercase text-gray-900 dark:text-gray-300 w-16 flex items-center justify-end">
                      {notification ? t("Notifications.on") : t("Notifications.off")}
                    </span>

                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={notification}
                      onChange={(event: any) => {
                        onChageNotification(event.target.checked);
                        // toggleBtn({
                        //   enableOtherNotification: event.target.checked,
                        //   enableDailyRemainder: dailyAnnouncement,
                        // });
                      }}
                    />
                    <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                  </label>
                </div>
              </div>
            </li>
            <li className="py-3 sm:py-4">
              <div className="flex items-center">
                <div className="flex-shrink-0 w-[16px] flex items-center">
                  <img
                    className="w-[16px] h-[16px]"
                    alt="No Image"
                    src={dailyReminderImg}
                  />
                </div>
                <div className="flex-1 min-w-0 ms-4 flex items-center">
                  <Tooltip
                    title={t("UserSettings.dailRemiderNotification")}
                    position="right"
                    className="bg-[#16171C] p-2 text-center border dark:border-white z-[10000] text-xs -mt-2 ml-2"
                  >
                    <p className="text-sm font-helveticaRegular truncate text-gray-900 dark:text-white my-0">
                      {t("UserSettings.mobilePushNotifications")}
                    </p>
                  </Tooltip>
                </div>
                <div className="inline-flex items-center text-sm font-light text-gray-900 dark:text-white">
                  <label className="inline-flex items-center cursor-pointer">
                    <span className="ms-3 px-4 text-sm font-medium uppercase text-gray-900 dark:text-gray-300 w-16 flex items-center justify-end">
                      {dailyAnnouncement ? t("Notifications.on") : t("Notifications.off")}
                    </span>

                    <input
                      type="checkbox"
                      // defaultChecked={notification}
                      className="sr-only peer"
                      checked={dailyAnnouncement}
                      onChange={(event: any) => {
                        onChageDailyAnnouncement(event.target.checked);
                        // toggleBtn({
                        //   enableOtherNotification: notification,
                        //   enableDailyRemainder: event.target.checked,
                        // });
                      }}
                    />
                    <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </Card>
    </>
  );
};
